module.exports = __webpack_public_path__ + "static/media/10a.08b7088e.jpg";